import React, { useState } from 'react';
import { RoleTable } from '@/widgets/role-table';
import { RoleDetailsDialog } from '@/widgets/role-details';
import { CreateRoleForm, EditRoleForm } from '@/widgets/role-form';
import { useDeleteRole } from '../../shared/lib/hooks/use-roles';
import { useAuthStore } from '@/app/store/auth-store';
import type { Role } from '@/shared/types';

export const RolesPage: React.FC = () => {
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [createFormOpen, setCreateFormOpen] = useState(false);
  const [editFormOpen, setEditFormOpen] = useState(false);
  
  // Auth store for permissions
  const { hasPermission } = useAuthStore();
  
  // Mutations
  const deleteRoleMutation = useDeleteRole();
  
  // Permission checks
  const canWriteRoles = hasPermission('roles:write');
  
  // Handlers
  const handleCreateRole = () => {
    setCreateFormOpen(true);
  };
  
  const handleEditRole = (role: Role) => {
    setSelectedRole(role);
    setEditFormOpen(true);
  };
  
  const handleViewRole = (role: Role) => {
    setSelectedRole(role);
    setDetailsDialogOpen(true);
  };
  
  const handleDeleteRole = async (role: Role) => {
    try {
      await deleteRoleMutation.mutateAsync(role.id);
    } catch (error) {
      // Error is handled by the mutation hook
      console.error('Failed to delete role:', error);
    }
  };

  return (
    <div className="container mx-auto py-3 sm:py-6 px-0">
      <RoleTable
        onCreateRole={handleCreateRole}
        onEditRole={handleEditRole}
        onViewRole={handleViewRole}
        onDeleteRole={handleDeleteRole}
      />
      
      <RoleDetailsDialog
        role={selectedRole}
        open={detailsDialogOpen}
        onOpenChange={setDetailsDialogOpen}
        onEdit={handleEditRole}
        canEdit={canWriteRoles}
      />
      
      <CreateRoleForm
        open={createFormOpen}
        onOpenChange={setCreateFormOpen}
      />
      
      <EditRoleForm
        role={selectedRole}
        open={editFormOpen}
        onOpenChange={setEditFormOpen}
      />
    </div>
  );
};